module.exports = __webpack_public_path__ + "4220541ed29ca6ae4b6909e921a35e9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/humi-donut.png
// module id = 762
// module chunks = 2